export function decode(value: string, shift: number) {
  let current = value;
  for (let i = shift; i >= 1; i--) {
    const arr = current.split('').reverse();
    const nilVal = arr[arr.length - i];
    arr[arr.length - i] = arr[0];
    arr[0] = nilVal;
    current = arr.join('');
  }
  return current;
}
